// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2vJFU","overflowing":"ReadFullNote_overflowing__2HrAi"};